import {
	addCompany,
	deleteCompany,
	deleteLogo,
	getCompanies,
	getCompanyAvailableLanguages,
	getOperatorTinyCompanies,
	getSelectedCompanies,
	getTinyCompanies,
	getTinyCompaniesWithOperator,
	updateCompany,
	uploadLogo
} from '../helpers/companyService';
import {checkError, closeAlert, receiveErrorAlert, receiveSuccessAlert} from './commonsActions';

/*
 * action types
 */

export const FETCH_SELECTED_COMPANIES_BEGIN   = 'FETCH_SELECTED_COMPANIES_BEGIN';
export const FETCH_SELECTED_COMPANIES_SUCCESS = 'FETCH_SELECTED_COMPANIES_SUCCESS';

export const FETCH_COMPANIES_BEGIN   = 'FETCH_COMPANIES_BEGIN';
export const FETCH_COMPANIES_SUCCESS = 'FETCH_COMPANIES_SUCCESS';
export const FETCH_COMPANIES_ERROR = 'FETCH_COMPANIES_ERROR';

export const FETCH_TINY_COMPANIES_BEGIN   = 'FETCH_TINY_COMPANIES_BEGIN';
export const FETCH_TINY_COMPANIES_SUCCESS = 'FETCH_TINY_COMPANIES_SUCCESS';
export const FETCH_TINY_COMPANIES_ERROR = 'FETCH_TINY_COMPANIES_ERROR';

export const FETCH_TINY_COMPANIES_WITH_OPERATOR_BEGIN   = 'FETCH_TINY_COMPANIES_WITH_OPERATOR_BEGIN';
export const FETCH_TINY_COMPANIES_WITH_OPERATOR_SUCCESS = 'FETCH_TINY_COMPANIES_WITH_OPERATOR_SUCCESS';
export const FETCH_TINY_COMPANIES_WITH_OPERATOR_ERROR = 'FETCH_TINY_COMPANIES_WITH_OPERATOR_ERROR';

export const SAVE_COMPANY_BEGIN   = 'SAVE_COMPANY_BEGIN';
export const SAVE_COMPANY_SUCCESS = 'SAVE_COMPANY_SUCCESS';
export const SAVE_COMPANY_ERROR = 'SAVE_COMPANY_ERROR';

export const FETCH_COMPANY_AVAILABLE_LANGUAGES_BEGIN = 'FETCH_COMPANY_AVAILABLE_LANGUAGES_BEGIN';
export const FETCH_COMPANY_AVAILABLE_LANGUAGES_SUCCESS = 'FETCH_COMPANY_AVAILABLE_LANGUAGES_SUCCESS';

export const FETCH_OPERATOR_TINY_COMPANIES_BEGIN = 'FETCH_OPERATOR_TINY_COMPANIES_BEGIN';
export const FETCH_OPERATOR_TINY_COMPANIES_SUCCESS = 'FETCH_OPERATOR_TINY_COMPANIES_SUCCESS';
/*
 * action creators
 */

export const fetchCompaniesBegin = () => ({
	type: FETCH_COMPANIES_BEGIN
});

export const fetchCompaniesSuccess = companies => ({
	type: FETCH_COMPANIES_SUCCESS,
	payload: {
		companies: companies.data,
		numberOfElements : companies.numberOfElements,
		totalElements: companies.totalElements,
		totalPages: companies.totalPages
	}
});

export const fetchCompaniesError = error => ({
	type: FETCH_COMPANIES_ERROR,
	payload: {
		error: error
	}
});

export const fetchTinyCompaniesBegin = () => ({
	type: FETCH_TINY_COMPANIES_BEGIN
});

export const fetchTinyCompaniesSuccess = tinyCompanies => ({
	type: FETCH_TINY_COMPANIES_SUCCESS,
	payload: {
		tinyCompanies: tinyCompanies.data,
		totalElements: tinyCompanies.totalElements
	}
});

export const fetchTinyCompaniesError = error => ({
	type: FETCH_TINY_COMPANIES_ERROR,
	payload: {
		error: error
	}
});

export const fetchTinyCompaniesWithOperatorBegin = () => ({
	type: FETCH_TINY_COMPANIES_WITH_OPERATOR_BEGIN
});

export const fetchTinyCompaniesWithOperatorSuccess = tinyCompanies => ({
	type: FETCH_TINY_COMPANIES_WITH_OPERATOR_SUCCESS,
	payload: {
		tinyCompanies: tinyCompanies.data,
		totalElements: tinyCompanies.totalElements
	}
});

export const fetchTinyCompaniesWithOperatorError = error => ({
	type: FETCH_TINY_COMPANIES_WITH_OPERATOR_ERROR,
	payload: {
		error: error
	}
});

export const fetchSelectedCompaniesBegin = () => ({
	type: FETCH_SELECTED_COMPANIES_BEGIN
});

export const fetchSelectedCompaniesSuccess = companies => ({
	type: FETCH_SELECTED_COMPANIES_SUCCESS,
	payload: {
		selectedCompanies: companies.data
	}
});

export const saveCompanyBegin = () => ({
	type: SAVE_COMPANY_BEGIN
});

export const saveCompanySuccess = company => ({
	type: SAVE_COMPANY_SUCCESS,
	payload: {
		company: company.data
	}
});

export const saveCompanyError = error => ({
	type: SAVE_COMPANY_ERROR,
	payload: {
		error: error
	}
});

export const fetchCompanies = query => dispatch => {
	dispatch(fetchCompaniesBegin());
	return getCompanies(query).then(res => {
		console.log('company response')
		dispatch(fetchCompaniesSuccess(res));
		return res
	}, error => {
		dispatch(fetchCompaniesError(error))
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const fetchTinyCompanies = () => dispatch => {
	dispatch(fetchTinyCompaniesBegin());
	return getTinyCompanies().then(res => {
		console.log('tiny company response')
		dispatch(fetchTinyCompaniesSuccess(res));
		return res
	}, error => {
		dispatch(fetchTinyCompaniesError(error))
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const fetchTinyCompaniesWithOperator = query => dispatch => {
	dispatch(fetchTinyCompaniesWithOperatorBegin());
	return getTinyCompaniesWithOperator(query).then(res => {
		console.log('tiny company response')
		dispatch(fetchTinyCompaniesWithOperatorSuccess(res));
		return res
	}, error => {
		dispatch(fetchTinyCompaniesWithOperatorError(error))
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const fetchSelectedCompanies = companyIds => dispatch => {
	dispatch(fetchSelectedCompaniesBegin());
	return getSelectedCompanies(companyIds).then(res => {
		console.log('company___', res);
		dispatch(fetchSelectedCompaniesSuccess(res));
		return res
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const saveNewCompany = newCompany => dispatch => {
	dispatch(saveCompanyBegin());
	return addCompany(newCompany).then(res => {
		dispatch(saveCompanySuccess(res));
		dispatch(fetchCompanies());
		return res;
	}, error => {
		dispatch(saveCompanyError(error))
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const delCompany = companyId => dispatch => {
	return deleteCompany(companyId).then(res => {
		dispatch(fetchCompanies());
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const updateSingleCompany = company => {
	return dispatch => {
		return updateCompany({
			id: company.id,
			name: company.name,
			cityGeonameId: company.cityGeonameId,
			countryCode: company.countryCode,
			languageId: company.languageId,
			email: company.email,
			manager: company.manager,
			phoneNumber: company.phone,
			skype: company.skype,
			status: company.status,
			types: Array.isArray(company.types) ? company.types : [company.types],
			newUserDefaultPassword: company.newUserDefaultPassword
		}).then(res => {
			dispatch(receiveSuccessAlert('Success'));
			//dispatch(fetchCompanies(true));
			return res;
		}, error => {
			dispatch(checkError(error));
			dispatch(receiveErrorAlert(error));
			setTimeout(() => {
				dispatch(closeAlert());
			}, 2000);
		})
	};
};

export const uploadCompanyLogo = (companyId, logo) => dispatch => {
	const data = new FormData();
	data.append('logo', logo);
	return uploadLogo(companyId, data).then(res => {
		console.log('upload company icon response')
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const deleteCompanyLogo = (companyId) => dispatch => {
	return deleteLogo(companyId)
		.then(res => {
			return res;
		}, error => {
			dispatch(checkError(error));
			dispatch(receiveErrorAlert(error));
			setTimeout(() => {
				dispatch(closeAlert());
			}, 2000);
		})
};

export const fetchCompanyAvailableLanguages = () => dispatch => {
    dispatch({
        type: FETCH_COMPANY_AVAILABLE_LANGUAGES_BEGIN
    });
    return getCompanyAvailableLanguages()
        .then(res => {
            dispatch({
                type: FETCH_COMPANY_AVAILABLE_LANGUAGES_SUCCESS,
                payload: {
                    companyLanguages: res.data,
                }
            });
            return res
        }, error => {
            dispatch(checkError(error));
            setTimeout(() => {
                dispatch(closeAlert());
            }, 2000);
        })
};

export const fetchOperatorTinyCompanies = () => dispatch => {
	dispatch({
		type: FETCH_OPERATOR_TINY_COMPANIES_BEGIN
	});
	return getOperatorTinyCompanies()
		.then(res => {
			dispatch({
				type: FETCH_OPERATOR_TINY_COMPANIES_SUCCESS,
				payload: {
					operatorTinyCompanies: res.data,
				}
			});
			return res
		}, error => {
			dispatch(checkError(error));
			setTimeout(() => {
				dispatch(closeAlert());
			}, 2000);
		})
};



// WEBPACK FOOTER //
// ./src/actions/companyActions.js